var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{attrs:{"items":_vm.items}}),_c('v-divider'),_c('add-client',{staticClass:"mt-5",attrs:{"client":_vm.client,"agencies":_vm.agencies},on:{"create":function($event){return _vm.createClient($event)},"update":function($event){return _vm.update_Client($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }